module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }